// utils/invoices.js
export const getRemaining = (invoice) => {
    const total = parseFloat(invoice.total || 0);
    const discount = parseFloat(invoice.discount || 0);
    const payments = invoice.payments?.reduce(
      (sum, p) => sum + parseFloat(p.amount || 0),
      0
    ) || 0;
  
    return (total - discount - payments).toFixed(2);
  };
  
